export default "__VITE_ASSET__BjE2yuEt__";